import {
  Dialog,
  DialogTitle,
  Typography,
  Grid,
  makeStyles,
  DialogContent,
  CircularProgress,
  TextField,
  MenuItem,
  Box,
  IconButton,
  Button,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";

import CloseIcon from "@material-ui/icons/Close";
// import {
//   fetchUserStatus,
//   fetchViewSponsorDetails,
//   updateEcosystemDetails,
// } from "../../../../containers/actions/ecosystemActions";
import { useDispatch, useSelector } from "react-redux";
// import {
//   FETCH_ROLES_AND_TYPES,
//   FETCH_VIEW_SPONSOR_DETAILS,
//   FETCH_VIEW_SPONSOR_DETAILS_LOADING,
//   UPDATE_ECOSYSTEM_DETAILS,
// } from "../../../../containers/actions/types";
import PhoneInput from "react-phone-input-2";
import usePrevious from "../../../common/helperFunctions/usePrevious";

import { Country, State, City } from "country-state-city";
import postalCodes from "postal-codes-js";
import { parsePhoneNumberFromString } from "libphonenumber-js";
// import PhoneInput from "react-phone-input-2";
// import EmailPopup from "./EmailPopup";
import CreateIcon from "@material-ui/icons/Create";
import { ChevronRight, Edit } from "@material-ui/icons";
import BackDropLoading from "../../../common/helperFunctions/BackDropLoading";
import {
  fetchAllSponsorNetworks,
  fetchSelectedSponsorDetails,
  updateSponsorNetworkDetails,
} from "../../../../containers/actions/netwrokActions";
import {
  FETCH_ALL_SPONSOR_NETWORKS_LOADING,
  FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
  UPDATE_SPONSOR_NETWORK_DETAILS,
} from "../../../../containers/actions/types";
import UpdateSuccessDialog from "./UpdateSuccessDialog";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#F5F9FF",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },

  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },

    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
  },
  required: {
    color: "red",
  },
  cancelBtn: {
    border: "1px solid #000000de",
    backgroundColor: "white",
    color: "black",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
}));

const UpdateScreen = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    openDialog,
    rowData,
    handleCloseUpdateScreen,
    //  handleRefresh
  } = props;

  console.log("rowData", rowData);
  const [sponsorDetails, setSponsorDetails] = useState({
    sponsorName: "",
    orgCode: "",
    selectedCountry: "",
    states: [],
    selectedState: "",
    cities: [],
    selectedCity: "",
    postCode: "",
    streetAddress1: "",
    streetAddress2: "",
    selectedStatus: "",
    sponsorShortFormName: "",
  });

  const [adminDetails, setAdminDetails] = useState({
    fullName: "",
    emailAddress: "",
    phone: "",
    countryCode: "in",
  });

  const [newEmailAddress, setNewEmailAddress] = useState("");

  const [errors, setErrors] = useState({
    sponsorName: "",
    selectedCountry: "",
    selectedState: "",
    selectedCity: "",
    postCode: "",
    sponsorShortFormName: "",
    streetAddress1: "",
    streetAddress2: "",
    selectedStatus: "",
    fullName: "",
    emailAddress: "",
    phone: "",
  });

  console.log("sponsorDetails in update screen", sponsorDetails);

  const [fetchedData, setFetchedData] = useState({});
  const [userStatusesData, setUserStatusesData] = useState([]);

  const [emailPopup, setEmailPopup] = useState(false);

  const [open, setOpen] = useState(false);

  const [newStatus, setNewStatus] = useState("");

  const handleOpenEmailPopup = () => {
    setEmailPopup(true);
  };

  const handleCloseEmailPopup = () => {
    setEmailPopup(false);
  };

  useEffect(() => {
    dispatch({
      type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
      payload: true,
    });
    dispatch(
      fetchSelectedSponsorDetails({
        sponsorId: rowData.organizationId,
        ecosystemId: rowData.ecosystemId,
      })
    );
    // dispatch(fetchUserStatus());
  }, []);

  let fetchViewSponsorLoading = useSelector(
    (state) => state.network.selectedSponsorDetailsLoading
  );

  let fetchViewSponsorData = useSelector(
    (state) => state?.network?.selectedSponsorDetails || []
  );

  const updateSponsorDetails = useSelector(
    (state) => state?.network?.updateSponsorDetails || {}
  );

  const prevUpdateSponsorDetails = usePrevious(updateSponsorDetails);

  console.log("fetchViewSponsorData", fetchViewSponsorData);
  let prevFetchViewSponsorData = usePrevious(fetchViewSponsorData);

  let fetchErrors = useSelector((state) =>
    state?.network?.selectedSponsorDetails
      ? state?.network?.selectedSponsorDetails
      : {
          status: "false",
          errror: "Something went wrong. Please contact Schrocken Support.",
        }
  );

  let userStatuses = useSelector((state) =>
    state.ecosystems.userStatuses?.statusData
      ? state.ecosystems.userStatuses.statusData
      : []
  );

  let prevUserStatuses = usePrevious(userStatuses);

  // useEffect(() => {
  //   if (
  //     JSON.stringify(fetchViewSponsorData) !==
  //     JSON.stringify(prevFetchViewSponsorData)
  //   ) {
  //     setSponsorDetails({
  //       ...sponsorDetails,
  //       sponsorName: rowData?.sponsorName,
  //       orgCode: rowData?.organizationCode,
  //       selectedCountry:
  //         Country.getAllCountries().find(
  //           (country) =>
  //             country.name === rowData?.country) ?? "Country not found.",
  //       selectedState:
  //        rowData?.state ?? "State not found.",
  //       selectedCity: rowData?.city,
  //       postCode: rowData?.postCode,
  //       streetAddress1: rowData?.address1,
  //       streetAddress2: rowData?.address2,
  //       selectedStatus: rowData?.status ,
  //     });
  //     setAdminDetails({
  //       ...adminDetails,
  //       fullName: fetchViewSponsorData.adminDetails?.name,
  //       emailAddress: fetchViewSponsorData.adminDetails?.emailAddress,
  //       phone: fetchViewSponsorData.adminDetails?.phoneNumber,
  //     });
  //     setFetchedData(fetchViewSponsorData);
  //   }
  //   // if (JSON.stringify(userStatuses) !== JSON.stringify(prevUserStatuses)) {
  //   //   setUserStatusesData(userStatuses);
  //   //   // const defaultStatus = userStatuses.find(
  //   //   //   (status) => status.statusText === "Active"
  //   //   // );
  //   //   //   setSponsorDetails({
  //   //   //     ...sponsorDetails,
  //   //   //     selectedStatus: defaultStatus ? defaultStatus.statusText : "",
  //   //   //   });
  //   // }
  // }, [
  //   fetchViewSponsorData,
  //   prevFetchViewSponsorData,
  //   // userStatuses,
  //   // prevUserStatuses,
  // ]);

  useEffect(() => {
    if (
      JSON.stringify(fetchViewSponsorData) !==
        JSON.stringify(prevFetchViewSponsorData) &&
      fetchViewSponsorData?.SponsorDetails
    ) {
      setSponsorDetails({
        ...sponsorDetails,
        sponsorName: fetchViewSponsorData?.SponsorDetails[0]?.sponsorName,
        sponsorShortFormName:
          fetchViewSponsorData?.SponsorDetails[0]?.sponsorShortFormName,
        orgCode: fetchViewSponsorData?.SponsorDetails[0]?.organizationCode,
        selectedStatus: fetchViewSponsorData?.SponsorDetails[0]?.status,
        // selectedCountry: fetchViewSponsorData?.SponsorDetails[0]?.country,
        // state:
        //    fetchViewSponsorData?.SponsorDetails[0]?.state,
        selectedCountry:
          Country.getAllCountries().find(
            (country) =>
              country.name === fetchViewSponsorData?.SponsorDetails[0]?.country
          )?.isoCode ?? "Country not found.",
        selectedState:
          State.getStatesOfCountry(
            Country.getAllCountries().find(
              (country) =>
                country.name ===
                fetchViewSponsorData?.SponsorDetails[0]?.country
            )?.isoCode ?? "Country not found."
          ).find(
            (state) =>
              state.name === fetchViewSponsorData?.SponsorDetails[0]?.state
          )?.isoCode ?? "State not found.",
        selectedCity: fetchViewSponsorData?.SponsorDetails[0].city,
        postCode: fetchViewSponsorData?.SponsorDetails[0]?.postCode,
        streetAddress1: fetchViewSponsorData?.SponsorDetails[0]?.streetAddress1,
        streetAddress2: fetchViewSponsorData?.SponsorDetails[0]?.streetAddress2,
        saasUserId: fetchViewSponsorData?.SponsorDetails[0]?.saasUserId,
        // selectedStatus: fetchViewSponsorData?.SponsorDetails[0]?.status,
      });
      setAdminDetails({
        ...adminDetails,
        fullName: fetchViewSponsorData?.SponsorDetails[0]?.fullName,
        emailAddress: fetchViewSponsorData?.SponsorDetails[0]?.emailAddress,
        phone: fetchViewSponsorData?.SponsorDetails[0]?.phoneNumber,
      });
      setFetchedData(fetchViewSponsorData);
    }

    // if (JSON.stringify(userStatuses) !== JSON.stringify(prevUserStatuses)) {
    //   setUserStatusesData(userStatuses);

    // }
  }, [
    fetchViewSponsorData,
    prevFetchViewSponsorData,
    // userStatuses,
    // prevUserStatuses,
  ]);
  console.log("adminDetails", adminDetails);
  const didMountRef = useRef(false);

  const [updateError, setUpdateError] = useState(false);
  const [updatedData, setUpdatedData] = useState({});

  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  // const updatedEcosystemDetails = useSelector(
  //   (state) => state.ecosystems?.updateEcosystemDetails || {}
  // );
  // const prevUpdatedEcosystemDetails = usePrevious(updatedEcosystemDetails);

  useEffect(() => {
    if (didMountRef.current) {
      // Perform a deep comparison using isEqual from lodash

      // if (!isEqual(brandOwnerInformation, prevBrandOwnerInformation)) {
      if (
        JSON.stringify(updateSponsorDetails) !==
        JSON.stringify(prevUpdateSponsorDetails)
      ) {
        if (updateSponsorDetails.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdatedData(updateSponsorDetails);
          setOpenSuccessDialog(true);
        } else if (updateSponsorDetails.status === false) {
          // setLoading(false);
          setUpdateError(true);
          scrollToTop();
          setUpdatedData(updateSponsorDetails);
          setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [updateSponsorDetails, prevUpdateSponsorDetails]);

  const handleUpdate = () => {
    setUpdateError(false);
    dispatch({
      type: UPDATE_SPONSOR_NETWORK_DETAILS,
      payload: {},
    });
    // const updatePayload = {};
    // if (
    //   adminDetails.emailAddress !==
    //   fetchViewSponsorData.adminDetails.emailAddress
    // ) {

    //     const data= {
    //  sponsorId:  2,
    // ecosystemId:   1,
    // streetAddress1:   "",
    // streetAddress2:   "",
    // city:   "",
    // state:   "",
    // postCode:   "",
    // country:   "",
    // orgStatus:   "",
    // fullName:   "",
    // phoneNumber:   "",
    // emailAddress:   ""

    //     }

    const data = {
      sponsorId: rowData.organizationId ?? "",
      ecosystemId: rowData.ecosystemId ?? "",
      streetAddress1: sponsorDetails?.streetAddress1 ?? "",
      streetAddress2: sponsorDetails?.streetAddress2 ?? "",
      saasUserId: sponsorDetails?.saasUserId ?? "",
      city: sponsorDetails?.selectedCity ?? "",
      state:
        State.getStatesOfCountry(sponsorDetails.selectedCountry).find(
          (state) => state.isoCode === sponsorDetails?.selectedState
        )?.name ?? "",
      postCode: sponsorDetails?.postCode ?? "",
      country:
        Country.getAllCountries().find(
          (country) => country.isoCode === sponsorDetails?.selectedCountry
        )?.name ?? "",
      orgStatus: sponsorDetails?.selectedStatus ?? "", // selectedStatus mapped as orgStatus
      fullName: adminDetails?.fullName ?? "",
      phoneNumber: adminDetails?.phone ?? "",
      emailAddress: adminDetails?.emailAddress ?? "",
    };
    // console.log("data", data);
    dispatch(updateSponsorNetworkDetails(data));
    // }
    // Compare each field with the original data and add to payload if changed
    // else {
    //   if (
    //     sponsorDetails.streetAddress1 !==
    //     fetchViewSponsorData.sponsorDetails.address1
    //   ) {
    //     updatePayload.streetAddress1 = sponsorDetails.streetAddress1;
    //   }
    //   if (
    //     sponsorDetails.streetAddress2 !==
    //     fetchViewSponsorData.sponsorDetails.address2
    //   ) {
    //     updatePayload.streetAddress2 = sponsorDetails.streetAddress2;
    //   }
    //   if (
    //     sponsorDetails.selectedCity !== fetchViewSponsorData.sponsorDetails.city
    //   ) {
    //     updatePayload.city = sponsorDetails.selectedCity;
    //   }
    //   if (
    //     sponsorDetails.selectedState !==
    //       State.getStatesOfCountry(
    //         Country.getAllCountries().find(
    //           (country) =>
    //             country.name === fetchViewSponsorData.sponsorDetails.country
    //         )?.isoCode ?? "Country not found."
    //       ).find(
    //         (state) => state.name === fetchViewSponsorData.sponsorDetails.state
    //       )?.isoCode ??
    //     "State not found."
    //   ) {
    //     updatePayload.state =
    //       State.getStatesOfCountry(sponsorDetails.selectedCountry).find(
    //         (state) => state.isoCode === sponsorDetails.selectedState
    //       )?.name ?? "State not found.";
    //   }
    //   if (
    //     sponsorDetails.postCode !== fetchViewSponsorData.sponsorDetails.postCode
    //   ) {
    //     updatePayload.postalCode = sponsorDetails.postCode;
    //   }
    //   if (
    //     sponsorDetails.selectedCountry !==
    //       Country.getAllCountries().find(
    //         (country) =>
    //           country.name === fetchViewSponsorData.sponsorDetails.country
    //       )?.isoCode ??
    //     "Country not found."
    //   ) {
    //     updatePayload.country =
    //       Country.getAllCountries().find(
    //         (country) => country.isoCode === sponsorDetails.selectedCountry
    //       )?.name ?? "Country not found.";
    //   }
    //   if (
    //     sponsorDetails.selectedStatus !==
    //     fetchViewSponsorData.sponsorDetails.status.statusText
    //   ) {
    //     updatePayload.status = sponsorDetails.selectedStatus;
    //     updatePayload.statusChangeFlag = true;
    //   }
    //   if (
    //     sponsorDetails.selectedStatus ===
    //     fetchViewSponsorData.sponsorDetails.status.statusText
    //   ) {
    //     updatePayload.statusChangeFlag = false;
    //   }
    //   // if (adminDetails.emailAddress !== originalData.email) {
    //   //   updatePayload.email = adminDetails.emailAddress;
    //   // }
    //   if (adminDetails.fullName !== fetchViewSponsorData.adminDetails.name) {
    //     updatePayload.fullName = adminDetails.fullName;
    //   }
    //   if (
    //     adminDetails.phone !== fetchViewSponsorData.adminDetails.phoneNumber
    //   ) {
    //     updatePayload.phoneNumber = adminDetails.phone;
    //   }

    //   // If there are any changes, dispatch the update action
    //   if (Object.keys(updatePayload).length > 0) {
    //     dispatch(
    //       updateSponsorNetworkDetails({
    //         organizationId: rowData.organizationId,
    //         ecosystemID: fetchViewSponsorData.ecosystemDetails.ecosystemId,
    //         ...updatePayload,
    //       })
    //     );
    //   }
    // }
  };

  const handleClose = () => {
    // dispatch({
    //   type: FETCH_VIEW_SPONSOR_DETAILS,
    //   payload: {},
    // });
    // dispatch({
    //   type: FETCH_ROLES_AND_TYPES,
    //   payload: [],
    // });
    handleCloseUpdateScreen();
  };

  const validateCountry = (value) => {
    return value === "" ? "Country is required" : "";
  };
  const handleCountryChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({
      ...sponsorDetails,
      selectedCountry: value,
      selectedState: "",
      selectedCity: "",
      postCode: "",
    });
    const errorMessage = validateCountry(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCountry: errorMessage,
      selectedState: "State is required",
      selectedCity: "City is required",
      postCode: "Post Code is required"
    }));
  };

  useEffect(() => {
    if (sponsorDetails.selectedCountry) {
      const states = State.getStatesOfCountry(sponsorDetails.selectedCountry);
      setSponsorDetails((prevDetails) => ({
        ...prevDetails,
        states: states,
        // selectedState: "",
        // postCode: "",
        cities: [],
      }));
    }
  }, [sponsorDetails.selectedCountry]);

  const validateState = (value) => {
    return value === "" ? "State is required" : "";
  };

  const handleStateChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({
      ...sponsorDetails,
      selectedState: value,
      selectedCity: "",
      postCode: "",
    });
    const errorMessage = validateState(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedState: errorMessage,
      selectedCity: "City is required",
      postCode: "Post Code is required"
    }));
  };

  // City Name handling functions

  useEffect(() => {
    if (sponsorDetails.selectedState) {
      const cities = City.getCitiesOfState(
        sponsorDetails.selectedCountry,
        sponsorDetails.selectedState
      );
      setSponsorDetails((prevDetails) => ({
        ...prevDetails,
        cities: cities,
        // selectedCity: "",
      }));
    }
  }, [sponsorDetails.selectedState]);

  const validateCity = (value) => {
    return value === "" ? "City is required" : "";
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, selectedCity: value, postCode: "" });
    const errorMessage = validateCity(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCity: errorMessage,
      postCode: "Post Code is required"
    }));
  };

  // Post Code handling functions

  const validatePostCode = (value, country) => {
    if (value.trim() === "") {
      return "Post Code is required";
    }
    if (country) {
      const isValid = postalCodes.validate(country, value);
      if (isValid === true) {
        return "";
      } else {
        return "Invalid postal code";
      }
    }
    return "";
  };

  const handlePostCodeChange = (event) => {
    const value = event.target.value;
    const country = sponsorDetails.selectedCountry;

    setSponsorDetails({ ...sponsorDetails, postCode: value });

    const errorMessage = validatePostCode(value, country);
    setErrors((prevErrors) => ({ ...prevErrors, postCode: errorMessage }));
  };

  const validateStreetAddress1 = (value) => {
    return value.trim() === "" ? "Street Address 1 is required" : "";
  };

  const handleStreetAddress1Change = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, streetAddress1: value });
    const errorMessage = validateStreetAddress1(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress1: errorMessage,
    }));
  };

  const handleStreetAddress1Blur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, streetAddress1: trimmed });
    }
    const errorMessage = validateStreetAddress1(trimmed);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress1: errorMessage,
    }));
  };

  const validateStreetAddress2 = (value) => {
    return value.trim() === "" ? "Street Address 2 is required" : "";
  };
  const handleStreetAddress2Change = (event) => {
    const value = event.target.value;
    setSponsorDetails({ ...sponsorDetails, streetAddress2: value });
    const errorMessage = validateStreetAddress2(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress2: errorMessage,
    }));
  };

  const handleStreetAddress2Blur = (event) => {
    // Trim leading and trailing spaces when user is done typing
    const trimmed = event.target.value.trim();
    if (trimmed !== event.target.value) {
      setSponsorDetails({ ...sponsorDetails, streetAddress2: trimmed });
    }
    const errorMessage = validateStreetAddress2(trimmed);
    setErrors((prevErrors) => ({
      ...prevErrors,
      streetAddress2: errorMessage,
    }));
  };

  const validateStatus = (value) => {
    return value === "" ? "Status is required" : "";
  };

  // const handleStatusChange = (event) => {
  //   const value = event.target.value;
  //   if (value !== fetchViewSponsorData?.SponsorDetails[0]?.status) {
  //     setNewStatus(value);
  //     setOpen(true);
  //   } else {
  //     setSponsorDetails({ ...sponsorDetails, selectedStatus: value });
  //     const errorMessage = validateStatus(value);
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       selectedStatus: errorMessage,
  //     }));
  //   }
  // };

  const handleStatusChange = (event) => {
    const value = event.target.value;
    if (value !== fetchViewSponsorData?.SponsorDetails[0]?.status) {
      setNewStatus(value);
      setOpen(true);
    } else {
      setNewStatus(value);
      setOpen(true);
      setSponsorDetails({ ...sponsorDetails, selectedStatus: value });
      const errorMessage = validateStatus(value);
      setErrors((prevErrors) => ({
        ...prevErrors,
        selectedStatus: errorMessage,
      }));
    }
  };

  console.log("newStatus", newStatus);
  const handleDialogClose = (confirmed) => {
    if (confirmed) {
      setSponsorDetails({ ...sponsorDetails, selectedStatus: newStatus });
      const errorMessage = validateStatus(newStatus);
      setErrors((prevErrors) => ({
        ...prevErrors,
        selectedStatus: errorMessage,
      }));
    }
    setOpen(false);
  };

  // const handleStatusChange = (event) => {
  //   const value = event.target.value;
  //   setSponsorDetails({ ...sponsorDetails, selectedStatus: value });
  //   const errorMessage = validateStatus(value);
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     selectedStatus: errorMessage,
  //   }));
  // };

  const validateFullName = (value) => {
    return value.trim() === "" ? "Full Name is required" : "";
  };

  const handleFullNameChange = (event) => {
    // Allow spaces while typing, but apply character filtering
    const value = event.target.value
      .replace(/[^a-zA-Z\s']/g, "")
      .replace(/(\s{2,}|'{2,})/g, "");
    setAdminDetails({ ...adminDetails, fullName: value });
    console.log("adminDetails", adminDetails, value);
    const errorMessage = validateFullName(value);
    setErrors((prevErrors) => ({ ...prevErrors, fullName: errorMessage }));
  };

  const handleFullNameBlur = (event) => {
    // Trim leading and trailing spaces when user is done typing, then apply character filtering
    const value = event.target.value
      .trim()
      .replace(/[^a-zA-Z\s']/g, "")
      .replace(/(\s{2,}|'{2,})/g, "");
    if (value !== adminDetails.fullName) {
      setAdminDetails({ ...adminDetails, fullName: value });
    }
    const errorMessage = validateFullName(value);
    setErrors((prevErrors) => ({ ...prevErrors, fullName: errorMessage }));
  };

  const validateEmailAddress = (value) => {
    if (value.trim() === "") {
      return "Email Address is required";
    } else if (!/\S+@\S+\.\S+/.test(value)) {
      return "Invalid email address";
    }
    return "";
  };

  const handleEmailAddressChange = (event) => {
    const value = event.target.value;
    // setAdminDetails({ ...adminDetails, emailAddress: value });
    setNewEmailAddress(value);
    const errorMessage = validateEmailAddress(value);
    setErrors((prevErrors) => ({ ...prevErrors, emailAddress: errorMessage }));
  };

  const handleSaveEmailAddress = () => {
    setAdminDetails({ ...adminDetails, emailAddress: newEmailAddress });
    setEmailPopup(false);
  };

  // Handle phone number change

  const validatePhone = (phone, countryCode) => {
    if (phone.trim() === "") {
      return "Enter Phone Number";
    }

    const parsedPhoneNumber = parsePhoneNumberFromString(
      phone,
      countryCode.toUpperCase()
    );
    if (!parsedPhoneNumber || !parsedPhoneNumber.isValid()) {
      return "Invalid Phone Number";
    }

    return "";
  };
  const handlePhoneChange = (phone, country) => {
    // Update the country code and phone state
    setAdminDetails((prevDetails) => ({
      ...prevDetails,
      countryCode: country.countryCode,
      phone: country.countryCode !== prevDetails.countryCode ? "" : phone,
    }));

    // Validate the phone number
    const errorMessage = validatePhone(phone, country.countryCode);
    setErrors((prevErrors) => ({ ...prevErrors, phone: errorMessage }));
  };

  const handleCloseSuccessDialog = () => {
    // handleRefresh();
    // dispatch({
    //   type: UPDATE_ECOSYSTEM_DETAILS,
    //   value: {},
    // });
    setOpenSuccessDialog(false);
    handleClose();

    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: "",
        statusFilter: "All",
        networkTypeIDFilter: [], // Pass an empty array for networkTypeIDFilter
      })
    );
  };

  const errRef = useRef();
  const scrollToTop = () => {
    setTimeout(
      () => errRef.current.scrollIntoView({ behavior: "smooth", block: "end" }),
      100
    );
  };

  return (
    <>
      <BackDropLoading />
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: "0px" }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant="h6" style={{ fontSize: "1.875rem" }}>
                  Update Sponsor Network
                </Typography>
                <Typography>
                  Please update the sponsor network details in the fields below.
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant="body2"
                className={classes.closeBtn}
                onClick={handleClose}
              >
                Cancel{" "}
                <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        {fetchViewSponsorLoading === true ? (
          <DialogContent>
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress thickness="7" />
            </div>
          </DialogContent>
        ) : fetchErrors.status === false ? (
          <Grid
            style={{
              paddingLeft: "150px",
              paddingRight: "150px",
              paddingTop: "30px",
            }}
          >
            <Typography
              style={{
                border: "2px solid rgb(255,0,0)",
                backgroundColor: "rgb(255,240,240)",
                Opacity: 1,
                textAlign: "center",
                padding: "0.8rem",
                fontSize: "0.875rem",
              }}
            >
              {fetchErrors.error}
            </Typography>
          </Grid>
        ) : (
          <DialogContent
            style={{
              paddingLeft: "150px",
              paddingTop: "32px",
            }}
          >
            {updateError === true && (
              <Grid
                ref={(el) => {
                  errRef.current = el;
                }}
                style={{
                  // paddingLeft: "150px",
                  paddingTop: "8px",
                  width: "93%",
                  paddingBottom: "16px",
                }}
              >
                {/* {Object.keys(updatedData.errorDescription).map((key) => ( */}
                <Typography
                  variant="h6"
                  style={{
                    border: "1px solid #FF0000",
                    backgroundColor: "#FFF0F0",
                    opacity: "1",
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  {updatedData.errorDescription}
                </Typography>
                {/* ))} */}
              </Grid>
            )}
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.inline}>
                  Sponsor Details
                </Typography>
                <hr className={classes.hrLine} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Sponsor Name
                </Typography>
                <Typography className={classes.textfieldWidth}>
                  {sponsorDetails?.sponsorName || "NA"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Sponsor Short Name
                </Typography>
                <Typography className={classes.textfieldWidth}>
                  {sponsorDetails?.sponsorShortFormName || "NA"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Street Address 1 <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={sponsorDetails.streetAddress1}
                  onChange={handleStreetAddress1Change}
                  onBlur={handleStreetAddress1Blur}
                  error={errors.streetAddress1 !== ""}
                  inputProps={{ maxLength: 40 }}
                  helperText={errors.streetAddress1}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^a-zA-Z0-9\s,.\-\/&]/g, "") // allow letters, digits, space, comma, dot, hyphen, slash, ampersand
                      .replace(/(\s{2,}|,{2,}|\.{2,}|-{2,}|\/{2,}|&{2,})/g, ""); // prevent repeating characters
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Street Address 2 <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={sponsorDetails.streetAddress2}
                  onChange={handleStreetAddress2Change}
                  onBlur={handleStreetAddress2Blur}
                  error={errors.streetAddress2 !== ""}
                  inputProps={{ maxLength: 40 }}
                  helperText={errors.streetAddress2}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^a-zA-Z0-9\s,.\-\/&]/g, "") // allow letters, digits, space, comma, dot, hyphen, slash, ampersand
                      .replace(/(\s{2,}|,{2,}|\.{2,}|-{2,}|\/{2,}|&{2,})/g, ""); // prevent repeating characters
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Country <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  select
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={sponsorDetails.selectedCountry}
                  onChange={handleCountryChange}
                  error={errors.selectedCountry !== ""}
                  helperText={errors.selectedCountry}
                >
                  {Country.getAllCountries().map((country) => (
                    <MenuItem key={country.isoCode} value={country.isoCode}>
                      {country.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>


              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  State <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  select
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={sponsorDetails.selectedState}
                  onChange={handleStateChange}
                  //   disabled={!selectedCountry}
                  error={errors.selectedState !== ""}
                  helperText={errors.selectedState}
                >
                  {sponsorDetails.states.length === 0 ? (
                    <MenuItem disabled>No States Found</MenuItem>
                  ) : (
                    sponsorDetails.states.map((state) => (
                      <MenuItem key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </MenuItem>
                    ))
                  )}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  City <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  select
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={sponsorDetails.selectedCity}
                  onChange={handleCityChange}
                  //   disabled={!selectedState}
                  error={errors.selectedCity !== ""}
                  helperText={errors.selectedCity}
                >
                  {sponsorDetails.cities.length === 0 ? (
                    <MenuItem disabled>No Cities Found</MenuItem>
                  ) : (
                    sponsorDetails.cities.map((city) => (
                      <MenuItem key={city.name} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))
                  )}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Post Code <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={sponsorDetails.postCode}
                  onChange={handlePostCodeChange}
                  error={errors.postCode !== ""}
                  inputProps={{ maxLength: 12 }}
                  helperText={errors.postCode}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^a-zA-Z0-9\s-]/g, "")
                      .replace(/(\s{2,}|-{2,})/g, ""); // Allow only digits, letters, spaces, and hyphens
                  }}
                />
              </Grid>



              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Status <span className={classes.required}>*</span>
                </Typography>

                {/* <TextField
                  size="small"
                  select
                  variant="outlined"
                  className={classes.textfieldWidth}
                  onChange={handleStatusChange}
                  value={sponsorDetails.selectedStatus}
                  error={errors.selectedStatus !== ""}
                  helperText={errors.selectedStatus}
                >
                  {userStatusesData.map((data) => (
                    <MenuItem key={data.statusId} value={data.statusText}>
                      {data.statusText}
                    </MenuItem>
                  ))}
                </TextField> */}

                <TextField
                  size="small"
                  select
                  variant="outlined"
                  className={classes.textfieldWidth}
                  onChange={handleStatusChange}
                  value={sponsorDetails.selectedStatus || ""}
                  error={errors.selectedStatus !== ""}
                  helperText={errors.selectedStatus}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Organization Code
                </Typography>
                <Typography className={classes.textfieldWidth}>
                  {sponsorDetails?.orgCode || "NA"}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={11}>
                <hr className={classes.hr} />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.inline}>
                  Admin Details
                </Typography>
                <hr className={classes.hrLine} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Full Name <span className={classes.required}>*</span>
                </Typography>

                <TextField
                  size="small"
                  variant="outlined"
                  className={classes.textfieldWidth}
                  value={adminDetails.fullName}
                  onChange={handleFullNameChange}
                  onBlur={handleFullNameBlur}
                  error={errors.fullName !== ""}
                  helperText={errors.fullName}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^a-zA-Z\s']/g, "")
                      .replace(/(\s{2,}|'{2,})/g, ""); // Allow only uppercase letters (A-Z), lowercase letters (a-z), spaces, hyphens, and apostrophes
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="body1"
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    //   justifyContent: "space-between",
                  }}
                >
                  Email Address
                  {/* <Box
                    style={{
                      border: "1px solid black",
                      borderRadius: "8px",
                      marginLeft: "64px",
                    }}
                  >
                    <IconButton
                      onClick={handleOpenEmailPopup}
                      style={{ padding: "4px", color: "black" }}
                    >
                      <Edit />
                    </IconButton>
                  </Box> */}
                </Typography>
                <Typography className={classes.textfieldWidth}>
                  {adminDetails?.emailAddress || "NA"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="body1"
                  style={{ fontWeight: "bold", marginBottom: "8px" }}
                >
                  Phone <span className={classes.required}>*</span>
                </Typography>

                <PhoneInput
                  country={
                    adminDetails.countryCode ? adminDetails.countryCode : "in"
                  }
                  value={adminDetails.phone}
                  onChange={(phone, country) =>
                    handlePhoneChange(phone, country)
                  }
                  defaultErrorMessage="error"
                  inputStyle={{
                    width: "85%",
                    height: "2.5rem",
                    borderColor: errors.phone ? "#f44336" : "#0000008a",
                  }}
                  error={errors.phone}
                  errorStyle={{
                    borderColor: "red", // Change this to the desired outline color when there's an error
                  }}
                  containerStyle={{
                    borderColor: errors.phone ? "#f44336" : "#0000008a",
                  }}
                  dropdownStyle={{
                    borderColor: errors.phone ? "#f44336" : "#0000008a",
                  }}
                />
                <Typography
                  variant="caption"
                  style={{
                    margin: errors.phone ? "14px 14 4px 0" : "14px 14px 0 14px",
                    color: errors.phone ? "#f44336" : "#0000008a",
                    fontSize: "0.75rem",
                  }}
                >
                  {errors.phone}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                style={{ paddingTop: "24px", paddingBottom: "24px" }}
              >
                <Typography>
                  <span style={{ fontWeight: "500" }}>Note: </span>All fields
                  marked with an asterisk (
                  <span style={{ color: "red" }}>*</span>) are mandatory.
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: "20px",
                    textTransform: "none",
                    marginRight: "7rem",
                  }}
                  disabled={
                    [
                      "sponsorName",
                      "selectedCountry",
                      "selectedState",
                      "selectedCity",
                      "postCode",
                      "streetAddress1",
                      "streetAddress2",
                      "selectedStatus",
                    ].some((field) => sponsorDetails[field] === "") ||
                    ["fullName", "emailAddress", "phone", "countryCode"].some(
                      (field) => adminDetails[field] === ""
                    ) ||
                    [
                      "sponsorName",
                      "selectedCountry",
                      "selectedState",
                      "selectedCity",
                      "postCode",
                      "streetAddress1",
                      "streetAddress2",
                      "selectedStatus",
                      "fullName",
                      // "emailAddress",
                      "phone",
                    ].some((field) => errors[field] !== "") ||
                    (fetchViewSponsorData?.SponsorDetails[0]?.fullName ===
                      adminDetails.fullName &&
                      fetchViewSponsorData?.SponsorDetails[0]?.emailAddress ===
                        adminDetails.emailAddress &&
                      fetchViewSponsorData?.SponsorDetails[0]?.phoneNumber ===
                        adminDetails.phone &&
                      fetchViewSponsorData?.SponsorDetails[0]?.country ===
                        (Country.getAllCountries().find(
                          (country) =>
                            country.isoCode === sponsorDetails.selectedCountry
                        )?.name || "Country not found.") &&
                      fetchViewSponsorData?.SponsorDetails[0]?.state ===
                        (State.getStatesOfCountry(
                          sponsorDetails.selectedCountry
                        ).find(
                          (state) =>
                            state.isoCode === sponsorDetails.selectedState
                        )?.name || "State not found.") &&
                      fetchViewSponsorData?.SponsorDetails[0].city ===
                        sponsorDetails.selectedCity &&
                      sponsorDetails.streetAddress1 ===
                        fetchViewSponsorData?.SponsorDetails[0]
                          ?.streetAddress1 &&
                      sponsorDetails.streetAddress2 ===
                        fetchViewSponsorData?.SponsorDetails[0]
                          ?.streetAddress2 &&
                      sponsorDetails.postCode ===
                        fetchViewSponsorData?.SponsorDetails[0]?.postCode &&
                      sponsorDetails.selectedStatus ===
                        fetchViewSponsorData?.SponsorDetails[0]?.status)
                  }
                  onClick={handleUpdate}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        )}

        {/* {emailPopup && (
          <EmailPopup
            openDialog={emailPopup}
            handleCloseEmailPopup={handleCloseEmailPopup}
            actualEmailAddress={fetchViewSponsorData.adminDetails.emailAddress}
            emailAddress={adminDetails.emailAddress}
            handleEmailAddressChange={handleEmailAddressChange}
            newEmailAddress={newEmailAddress}
            handleSaveEmailAddress={handleSaveEmailAddress}
            errors={errors}
          />
        )} */}

        <Dialog open={open} maxWidth="lg">
          <DialogTitle
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "32px",
            }}
          >
            <Typography style={{ fontSize: "1.5rem" }}>
              {newStatus === "Inactive"
                ? "Are you sure you want to Deactivate the Record?"
                : "Are you sure you want to Reactivate the Record?"}
            </Typography>
          </DialogTitle>
          <DialogContent
            style={{
              color: "black",
              display: "flex",
              justifyContent: "center",
              marginBottom: "24px",
            }}
          >
            <Typography style={{ fontSize: "1rem" }}>
              {newStatus === "Inactive"
                ? "This action will change the status to inactive and will not allow users to login."
                : "This action will change the status to active and will allow users to login."}
            </Typography>
          </DialogContent>
          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginBottom: "24px",
            }}
          >
            <Button
              onClick={() => handleDialogClose(false)}
              variant="contained"
              color="primary"
              className={classes.cancelBtn}
              endIcon={<ChevronRight />}
              style={{ borderRadius: "20px", padding: "5px 30px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleDialogClose(true)}
              variant="contained"
              color="primary"
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                padding: "5px 30px",
              }}
            >
              {newStatus === "Inactive"
                ? "Confirm Deactivation"
                : "Confirm Reactivation"}
            </Button>
          </DialogActions>
        </Dialog>

        {openSuccessDialog && (
          <UpdateSuccessDialog
            openDialog={openSuccessDialog}
            updatedData={updatedData}
            handleCloseSuccessDialog={handleCloseSuccessDialog}
            adminDetails={adminDetails}
          />
        )}
      </Dialog>
    </>
  );
};

export default UpdateScreen;
